const textFieldUserMyAccount = {
  nameHelp: 'Insira seu nome completo',
  password: 'Senha Atual',
  passwordNew: 'Nova Senha',
  passwordError: 'Mínimo de 6 caracteres',
  passwordNew2: 'Repita Nova Senha',
  PasswordNewError2: 'Senhas diferentes'
};

export default textFieldUserMyAccount;
